import * as React from "react";
const SvgLineHorizontalDoubleLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M19 8a1 1 0 1 1 0 2H5a1 1 0 0 1 0-2zm0 6a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2z", clipRule: "evenodd" }));
export default SvgLineHorizontalDoubleLine;
